import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=da164a5e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da164a5e')) {
      api.createRecord('da164a5e', component.options)
    } else {
      api.reload('da164a5e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=da164a5e&", function () {
      api.rerender('da164a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h84MOY71qHoH/JS/imageCarousel.vue"
export default component.exports